export default {
    noTranslation: 'no English translation available'
}
